<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import { mapActions } from "vuex";
// import { getUserInfo } from "@/api/system/user";
export default {
  name: "app",
  methods: {
    getuserInfoFuc() {}
  },
  async created() {
    // this.getuserInfoFuc()
    // debugger
    // console.log(this.$route);
    // if (this.$route.name !== 'downloadPage') {
    //   getUserInfo().then(res => {
    //     // console.log("res", res);
    //     const user = res.data.data;
    //     this.form = {
    //       account: user.account,
    //       id: user.id,
    //       avatar: user.avatar,
    //       name: user.name,
    //       realName: user.realName,
    //       phone: user.phone,
    //       email: user.email
    //     };
    //     sessionStorage.setItem("user_data", JSON.stringify(this.form));
    //   });
    // }
  }
};
</script>

<style lang="scss">
body {
  margin: 0px;
  padding: 0;
  width: 100%;
  min-width: 1440px;
  max-width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  background-color: rgba(0, 0, 0, .2);
}
.iconfont_12 {
    color: #8194B2;
    font-family: "iconfont" !important;
    font-size: 12px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.iconshujuku3 {
  color: #8194B2;
}
.iconyunshuju1 {
  color: #2D8CF0;
}
.iconjiekou {
  color: #ffa940;
}
.iconshuju1 {
  color: #2d8cf0;
}
.tree-img-box {
  display: inline-block;
  vertical-align: middle;
}
.el-tree {
  font-size: 12px;
  .custom-tree-node {
    .tree-node-icon {
      span {
        color: #808693;
      }
    }
  }
  .custom-tree-node-list {
    line-height: 28px;
  }
  .el-tree-node>.el-tree-node__children {
    overflow: inherit;
  }
  .el-tree-node__content>.el-tree-node__expand-icon {
    padding: 0;
  }
  .el-tree-node:focus>.el-tree-node__content {
    .custom-tree-node {
      .tree-node-title {
        color: #3296FA;
      }
    }
  }
  .el-tree-node__content:hover {
    .custom-tree-node {
      .tree-node-title {
        color: #3296FA;
      }
    }
  }
}
.phon-right{
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  height:calc(100vh - 102px);
  border-left: 1px solid #dcdee2;
  margin-top: 57px;
  .phon-right-img {
    margin-top: 32px;
  }
  img{
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    margin: auto;

  }
}
.avue-crud__dialog {
  .el-dialog__header {
    padding: 11px 16px;
    border-bottom: 1px solid #dcdee2;
    .el-dialog__title {
      font-size: 12px;
      font-weight: bold;
      color: #2e3f57;
    }
    .el-dialog__headerbtn {
      top: 15px;
    }
  }
  .el-dialog__body {
    padding: 16px;
    .el-form-item {
      margin-bottom: 12px;
    }
    .avue-input {
      width: 294px;
      .el-input {
        width: 100%;
      }
    }
    .avue-input-number {
      width: 294px !important;
      .el-input-number {
        width: 100%;
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #dcdee2;
    padding: 16px;
    .dialog-footer {
      .el-button + .el-button {
        margin-left: 8px;
      }
    }
  }
  .avue-drawer__header {
    padding: 11px 16px;
    .avue-drawer__title {
      font-size: 12px;
      font-weight: bold;
      color: #2e3f57;
    }
  }
  .avue-drawer__body {
    padding: 16px;
    .el-form-item {
      margin-bottom: 12px;
    }
    .el-form-item__content {
      width: 294px;
      .el-input {
        width: 100%;
      }
    }
  }
  .avue-drawer__footer {
    padding: 16px;
    border-top: 1px solid #dcdee2;
    .dialog-footer {
      .el-button + .el-button {
        margin-left: 8px;
      }
    }
  }
}
.el-tooltip__popper {
  max-width: 60%;
  max-height: 200px;
}
.form-item-pdleft {
  .el-form-item__content {
    padding-left: 8px;
  }
}
.table-name-img {
  display: inline-block;
  width: 16px;
  // padding-top: 2px;
  img {
    width: 12px;
    height: 12px;
  }
}
.table-name-title {
  display: inline-block;
  width: calc(100% - 16px);
  vertical-align: top;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.basic-table-canScroll {
  height: 100%;
  overflow-y: auto;
}
.el-textarea .el-input__count {
  background: transparent !important;
}
.el-table__empty-text {
  color: #aeaeb4 !important;
}
.el-button {
  height: 28px;
}
.el-button.is-circle {
  padding: 0 8px !important;
}
.new-task-modal {
  .el-radio {
    margin-right: 16px;
    .el-radio__label {
      padding-left: 4px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
    width: 106px;
    .el-checkbox__label {
      padding-left: 4px;
      font-size: 12px;
    }
  }
}
.output-modal {
  .el-dialog__body {
    height: auto !important;
  }
  .output-input {
    width: 393px;
  }
  .output-notice {
    padding-top: 14px;
    color: #aeaeb4;
    line-height: 28px;
    font-size: 12px;
  }
}
.detail-modal {
  .detail-content {
    text-align: justify;
    .content-row {
      font-size: 0;
      padding-bottom: 8px;
      .row-left {
        display: inline-block;
        width: 272px;
        margin-right: 16px;
        color: #2e4057;
        .left-title {
          display: inline-block;
          vertical-align: top;
          text-align: right;
          width: 48px;
          margin-right: 8px;
          line-height: 28px;
          font-size: 12px;
        }
        .left-content {
          display: inline-block;
          width: calc(100% - 56px);
          line-height: 28px;
          font-size: 12px;
          color: #637081;
          word-break: break-all;
        }
      }
      .row-right {
        display: inline-block;
        vertical-align: top;
        width: 272px;
        color: #2e4057;
        .right-title {
          text-align: right;
          display: inline-block;
          vertical-align: top;
          width: 48px;
          margin-right: 8px;
          line-height: 28px;
          font-size: 12px;
        }
        .right-content {
          display: inline-block;
          width: calc(100% - 56px);
          line-height: 28px;
          line-height: 28px;
          font-size: 12px;
          color: #637081;
          word-break: break-all;
        }
      }
      .row-line {
        .line-title {
          text-align: right;
          display: inline-block;
          vertical-align: top;
          line-height: 28px;
          width: 48px;
          margin-right: 8px;
          font-size: 12px;
        }
        .line-content {
          display: inline-block;
          word-break: break-all;
          width: calc(100% - 56px);
          line-height: 28px;
          line-height: 28px;
          font-size: 12px;
          color: #637081;
        }
      }
    }
    .content-row:last-child {
      padding-bottom: 0;
    }
  }
}
.import-modal {
  .el-form-item {
    display: block !important;
  }
  .el-upload {
    height: 28px;
  }
  .import-btn {
    // width: 72px;
    height: 28px;
  }
  .import-upload-tip {
    color: #aeaeb4;
    font-size: 12px;
  }
  .import-upload-file {
    .el-upload-list__item {
      margin-top: 4px !important;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      .el-icon-close {
        top: 8px;
      }
    }
  }
  .import-input {
    width: 100%;
  }
  .import-textarea {
    width: 100%;
    textarea {
      height: 145px;
      resize: none;
    }
  }
  .add-input-in {
    width: calc(100% - 32px);
    .el-input__inner {
      text-align: left;
    }
  }
  .add-input-word {
    display: inline-block;
    margin-left: 4px;
    width: 28px;
  }
}
.sord-modal {
  .el-dialog__body {
    height: 322px !important;
  }
  .fields-table {
    .el-table__body-wrapper {
      height: 256px;
      overflow-y: auto;
    }
    .table-do-btn {
      font-size: 0;
      .el-button--medium {
        border-radius: 0;
        font-size: 14px;
      }
      .el-button {
        vertical-align: middle;
        margin-left: 0 !important;
        color: #3296fa;
        border: 1px solid #3296fa;
        padding: 0;
        border-radius: 0;
        font-size: 14px;
        .el-icon-d-arrow-left {
          transform: rotate(90deg);
        }
        .el-icon-d-arrow-right {
          transform: rotate(90deg);
        }
      }
      .el-button:nth-of-type(1) {
        margin-right: 16px;
      }
    }
  }
}
.third-tabPositon {
  position: relative;
  .tabPositon-right {
    position: absolute;
    height: 28px;
    line-height: 28px;
    text-align: right;
    top: 16px;
    right: 14px;
    font-size: 0;
    .btn-two {
      vertical-align: middle;
      // width: 48px;
      height: 28px;
      font-size: 12px;
    }
  }
}
.third {
  width: 100%;
  min-width: 1208px;
  background-color: #f7f8fa;
  .third-menu-list {
    padding: 14px 14px 0 14px;
    background-color: #fff !important;
    border-bottom: solid 1px #e6e6e6 !important;
    .menu-back-icon {
      float: left;
      height: 42px;
      line-height: 42px;
      padding-right: 8px;
      margin: 0;
      font-size: 12px;
      color: #3296fa;
      cursor: pointer;
    }
    .el-menu-item.is-active {
      color: #3296fa !important;
    }
    .el-menu-item:not(.is-disabled):hover {
      color: #3296fa !important;
      // border-bottom: 2px solid #3296FA !important;
    }
    .el-menu-item {
      font-size: 14px;
      font-weight: bold;
      height: 42px;
      line-height: 42px;
    }
  }
  .el-cascader .el-input {
    width: 100%;
  }
  .third-headTab {
    .el-tabs__header {
      padding-top: 16px;
      background-color: #fff;
      margin: 0;
    }
    .el-tabs__nav:first-child {
      transform: translateX(16px);
    }
    .el-tabs__item {
      height: 32px;
      line-height: 32px;
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }
  .el-button {
    // padding: 0 !important;
    margin-left: 4px !important;
  }
  .third-formOne {
    width: 100%;
    background-color: #fff;
    height: 100vh;
    overflow-y: auto;
    font-size: 0;
    .el-table__body-wrapper {
      overflow-y: auto;
    }
    .formOne-tree-left {
      width: 250px;
      height: 100%;
      padding: 8px;
      overflow-x: auto;
      display: inline-block;
      .tree-head-title {
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        font-weight: bold;
        color: #2e3f57;
        border: 1px solid #dcdee2;
        border-bottom: 0;
        padding-left: 8px;
      }
      .left-tree {
        height: calc(100vh - 88px);
        padding: 8px;
        overflow-y: auto;
        border: 1px solid #dcdee2;
        position: relative;
        .el-tree {
          font-size: 12px;
          .custom-tree-node {
            .tree-node-icon {
              span {
                color: #808693;
              }
            }
          }
          .custom-tree-node-list {
            line-height: 28px;
          }
          .el-tree-node > .el-tree-node__children {
            overflow: inherit;
          }
          .el-tree-node__content > .el-tree-node__expand-icon {
            padding: 0;
          }
          .el-tree-node:focus > .el-tree-node__content {
            .custom-tree-node {
              .tree-node-title {
                color: #3296fa;
              }
            }
          }
          .el-tree-node__content:hover {
            .custom-tree-node {
              .tree-node-title {
                color: #3296fa;
              }
            }
          }
        }
        .el-tree--highlight-current
          .el-tree-node.is-current
          > .el-tree-node__content {
          .custom-tree-node-list {
            line-height: 28px;
            background-color: #eff7ff;
          }
          .custom-tree-node {
            line-height: 28px;
            background-color: #eff7ff;
            .tree-node-title {
              color: #3296fa;
            }
          }
        }
      }
    }
    .formOne-tree-right {
      vertical-align: top;
      display: inline-block;
      width: calc(100% - 250px);
    }
    .el-button {
      // padding: 0 !important;
      margin-left: 8px !important;
    }
    .formOne-backRouter {
      font-size: 0;
      padding: 16px;
      border-bottom: 1px solid #d4d4d7;
      .backRouter-content {
        height: 28px;
        line-height: 28px;
        .content-back {
          display: inline-block;
          font-size: 12px;
          color: #3296fa;
          vertical-align: top;
          cursor: pointer;
        }
        .content-shu {
          margin-left: 8px;
          width: 1px;
          height: 13px;
          background-color: #d4d4d7;
          display: inline-block;
          vertical-align: middle;
        }
        .content-crumb {
          padding-left: 8px;
          display: inline-block;
          vertical-align: middle;
          font-size: 12px;
          font-weight: bold;
          .el-breadcrumb__separator[class*="icon"] {
            margin: 0 4px;
          }
        }
      }
    }
    .formOne-flow {
      padding: 16px 16px 24px 16px;
      border-bottom: 1px solid #dcdee2;
      .flow-title {
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #2e4057;
        font-weight: bold;
      }
      .flow-step {
        .el-step.is-horizontal {
          height: 40px;
        }
        .el-step__icon.is-icon {
          width: 52px;
        }
        .el-step__head.is-process {
          color: #d4d4d7;
        }
        .el-step__icon {
          height: 20px;
          .el-step__icon-inner {
            font-size: 20px;
            font-weight: normal;
          }
        }
        .el-step__main {
          .el-step__title {
            font-size: 12px;
            line-height: 20px;
          }
          .el-step__title.is-process {
            font-weight: normal;
          }
          .el-step__title.is-wait {
            color: #2e4057;
          }
        }
      }
    }
    .formOne-btn {
      padding: 14px;
      font-size: 0;
      border-bottom: 1px solid #DCDEE2;
      position: fixed;
      z-index: 33;
      width: 100%;
      background: white;
      .btn-left {
        height: 28px;
        line-height: 28px;
        display: inline-block;
        width: 50%;
        font-size: 0;
        color: #2e3f57;
        font-weight: bold;
        vertical-align: top;
        .left-back-icon {
          font-size: 12px;
          color: #3296fa;
          cursor: pointer;
          display: inline-block;
          font-weight: normal;
        }
        .left-back-shu {
          display: inline-block;
          vertical-align: top;
          .left-back-shu-content {
            margin-left: 8px;
            margin-right: 8px;
            width: 1px;
            height: 12px;
            display: inline-block;
            background-color: #d4d4d7;
            vertical-align: middle;
          }
        }
        .left-back-content {
          display: inline-block;
          font-size: 14px;
        }
      }
      .btn-right {
        display: inline-block;
        width: 50%;
        height: 28px;
        line-height: 28px;
        text-align: right;
        .btn-two {
          vertical-align: middle;
          // width: 48px;
          height: 28px;
          font-size: 12px;
        }
        .btn-four {
          vertical-align: middle;
          // width: 72px;
          height: 28px;
          font-size: 12px;
        }
      }
    }
    .formOne-btnTwo {
      padding-top: 12px;
    }
    .formOne-forms {
      padding: 12px 16px 12px 16px;
      font-size: 0;
      .forms-one {
        border-top: 1px solid #dcdee2;
        padding-top: 12px;
        .one-title {
          font-size: 0;
          padding-bottom: 12px;
          .title-left {
            height: 28px;
            line-height: 28px;
            display: inline-block;
            vertical-align: top;
            width: 50%;
            .left-icon {
              font-size: 12px;
            }
            .left-content {
              padding-left: 8px;
              font-size: 12px;
              color: #2e4057;
              font-weight: bold;
            }
          }
          .title-right {
            height: 28px;
            line-height: 28px;
            display: inline-block;
            width: 50%;
            text-align: right;
            .right-span {
              font-size: 12px;
              color: #2e3f57;
              display: inline-block;
              vertical-align: top;
            }
            .btn-two {
              // width: 48px;
              height: 28px;
              font-size: 12px;
            }
            .btn-four {
              // width: 72px;
              height: 28px;
              font-size: 12px;
            }
          }
        }
        .one-list {
          font-size: 0;
          .el-checkbox {
            margin-right: 16px;
            .el-checkbox__label {
              padding-left: 4px;
              font-size: 12px;
            }
          }
          .el-date-editor .el-range__icon {
            line-height: 26px;
          }
          .el-date-editor .el-range-separator {
            line-height: 26px;
            padding: 0;
            margin: 0 4px;
          }
          .el-date-editor .el-range-input {
            width: 43%;
          }
          .el-range-editor.el-input__inner {
            padding: 0px 4px;
          }
          .list-one-line {
            display: inline-block;
            vertical-align: top;
            padding-left: 16px;
            // .one-detail-item {
            //   .el-form-item__label {
            //     padding: 0 8px 0 0;
            //   }
            // }
            // .el-form-item__label {
            //   line-height: 28px;
            // }
            // .el-form-item__content {
            //   line-height: 28px;
            // }
            .one-line-content {
              word-break: break-all;
              color: #637081;
            }
            .detail-content-number {
              cursor: pointer;
              color: #2d8cf0;
              text-decoration: underline;
            }
            .list-input {
              width: 292px;
            }
            .list-textarea {
              width: 292px;
            }
          }
          .list-one-line:first-child {
            padding-left: 0;
          }
          .list-circulation-line {
            display: inline-block;
            vertical-align: top;
            padding-right: 16px;
            .list-input {
              width: 287px;
            }
            .list-textarea {
              width: 287px;
            }
          }
          .list-circulation-line:last-child {
            padding-right: 0;
          }
          .list-two-line {
            .list-textarea {
              width: 676px;
              textarea {
                height: 98px;
                resize: none;
              }
            }
          }
          .list-detail-line {
            display: inline-block;
            vertical-align: top;
            padding-left: 16px;
            .el-form-item__label {
              padding: 0 8px 0 0;
            }
            // .el-form-item__label {
            //   line-height: 28px;
            // }
            .el-form-item__content {
              font-size: 12px;
              // line-height: 28px;
              color: #2e4057;
              .detail-content {
                width: 297px;
                word-break: break-all;
                color: #637081;
              }
              .detail-content-number {
                cursor: pointer;
                color: #2d8cf0;
                text-decoration: underline;
              }
            }
            .list-input {
              width: 292px;
            }
            .list-textarea {
              width: 292px;
            }
          }
          .list-detail-line:first-child {
            padding-left: 0;
          }
          .list-three-line {
            display: inline-block;
            vertical-align: top;
            padding-left: 16px;
            .list-input {
              width: 194px;
            }
            .list-textarea {
              width: 194px;
            }
          }
          .list-three-line:first-child {
            padding-left: 0;
          }
          .list-four-line {
            .list-textarea {
              width: 490px;
              textarea {
                height: 98px;
                resize: none;
              }
            }
          }
          .el-form-item {
            margin-bottom: 12px;
          }
          .list-input {
            width: 316px;
          }
          .list-textarea {
            width: 316px;
            textarea {
              height: 98px;
              resize: none;
            }
          }
          .list-upload-file {
            .upload-btn {
              // width: 72px;
              height: 28px;
              margin-left: 0 !important;
            }
            .list-upload-tip {
              color: #aeaeb4;
              font-size: 12px;
            }
            .el-upload {
              height: 28px;
            }
            .el-upload-list__item {
              margin-top: 4px !important;
              width: 316px;
              font-size: 12px;
              line-height: 28px;
              .el-upload-list__item-name {
                height: 28px;
              }
              .el-icon-close {
                top: 8px;
              }
            }
          }
          .list-upload-img {
            .el-icon-plus {
              color: #3296fa;
              font-size: 24px;
            }
            .list-upload-tip {
              color: #aeaeb4;
              font-size: 12px;
            }
            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
              position: relative;
              .list-upload-title {
                position: absolute;
                width: 100%;
                height: 28px;
                top: 24px;
                left: 0;
                color: #2e3f57;
              }
            }
            .el-upload-list__item {
              width: 100px;
              height: 100px;
              margin: 0 8px 0 0;
            }
          }
          .list-next-btn {
            // width: 72px;
            height: 28px;
            margin-left: 330px !important;
          }
        }
      }
      .forms-one:nth-of-type(1) {
        border-top: 0;
        padding-top: 0;
      }
    }
  }
  .formone-two {
    height: calc(100vh - 92px);
  }
  .third-formone-btn {
    background-color: #fff;
    padding: 14px;
    font-size: 0;
    border-bottom: 1px solid #dcdee2;
    .btn-left {
      height: 28px;
      line-height: 28px;
      display: inline-block;
      width: 50%;
      font-size: 0;
      color: #2e3f57;
      font-weight: bold;
      vertical-align: top;
      .left-back-icon {
        font-size: 12px;
        color: #3296fa;
        cursor: pointer;
        display: inline-block;
        font-weight: normal;
      }
      .left-back-shu {
        display: inline-block;
        vertical-align: top;
        .left-back-shu-content {
          margin-left: 8px;
          margin-right: 8px;
          width: 1px;
          height: 12px;
          display: inline-block;
          background-color: #d4d4d7;
          vertical-align: middle;
        }
      }
      .left-back-content {
        display: inline-block;
        font-size: 14px;
      }
    }
    .btn-right {
      display: inline-block;
      width: 50%;
      height: 28px;
      line-height: 28px;
      text-align: right;
      .btn-two {
        vertical-align: middle;
        // width: 48px;
        height: 28px;
        font-size: 12px;
      }
      .btn-four {
        vertical-align: middle;
        // width: 72px;
        height: 28px;
        font-size: 12px;
      }
    }
  }
  .third-rea {
    padding: 8px 8px 0 8px;
    background-color: #fff;
    .third-btn {
      height: 32px;
      line-height: 32px;
      font-size: 0;
      .btn-left {
        display: inline-block;
        width: 60px;
        font-size: 12px;
        color: #2e3f57;
        font-weight: bold;
        vertical-align: top;
      }
      .btn-right {
        display: inline-block;
        width: calc(100% - 60px);
        text-align: right;
        .btn-two {
          vertical-align: middle;
          // width: 48px;
          height: 24px;
          font-size: 12px;
        }
        .btn-shu {
          margin-left: 4px;
          width: 1px;
          height: 15px;
          background-color: #d4d4d7;
          display: inline-block;
          vertical-align: middle;
        }
        .btn-four {
          vertical-align: middle;
          // width: 72px;
          height: 24px;
          font-size: 12px;
        }
      }
    }
    .third-search {
      padding-bottom: 8px;
      .search-row {
        // padding-top: 8px;
        font-size: 0;
        .item-input {
          width: 216px;
        }
        .row-item {
          width: 25%;
          padding-top: 8px;
          display: inline-block;
          text-align: center;
          // .el-form-item__label {
          //   line-height: 28px;
          // }
          .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
          }
          // .el-form-item__content {
          //   line-height: 28px;
          // }
          .el-input {
            height: 28px;
          }
        }
      }
    }
  }
  .third-one {
    padding: 8px;
    font-size: 0;
    .one-left {
      display: inline-block;
      vertical-align: top;
      background-color: #fff;
      margin-right: 8px;
      width: 216px;
      .left-tab {
        position: relative;
        .tab-one {
          display: inline-block;
          text-align: center;
          vertical-align: top;
          height: 32px;
          line-height: 32px;
          width: 50%;
          cursor: pointer;
          .one-title {
            font-size: 12px;
            position: relative;
            display: inline-block;
            font-weight: bold;
          }
          .one-active::after {
            position: absolute;
            content: "";
            width: 100%;
            height: 2px;
            bottom: 0;
            left: 0;
            background-color: #3296fa;
            z-index: 2;
          }
        }
      }
      .left-tab::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #e4e7ed;
        z-index: 1;
      }
      // .left-tree {
      //   height: calc(100vh - 240px);
      //   overflow-y: auto;
      //   position: relative;
      //   font-size: 12px;
      //   .tree-refresh {
      //     position: absolute;
      //     cursor: pointer;
      //     z-index: 999;
      //     top: 8px;
      //     right: 8px;
      //   }
      //   .el-tree-node__content>.el-tree-node__expand-icon {
      //     padding: 0;
      //   }
      //   .el-tree-node>.el-tree-node__children {
      //     overflow: inherit;
      //   }
      // }
      .left-tree {
        height: calc(100vh - 240px);
        overflow-y: auto;
        position: relative;
        .tree-nodata {
          padding: 8px;
          top: 28px;
          font-size: 12px;
          position: absolute;
          color: #aeaeb4;
        }
        .tree-refresh {
          position: absolute;
          cursor: pointer;
          z-index: 999;
          top: 7px;
          right: 8px;
          font-size: 12px;
        }
        .el-tree {
          font-size: 12px;
          .custom-tree-node {
            .tree-node-icon {
              span {
                color: #808693;
              }
            }
          }
          .custom-tree-node-list {
            line-height: 28px;
          }
          .el-tree-node > .el-tree-node__children {
            overflow: inherit;
          }
          .el-tree-node__content > .el-tree-node__expand-icon {
            padding: 0;
          }
          .el-tree-node:focus > .el-tree-node__content {
            .custom-tree-node {
              .tree-node-title {
                color: #3296fa;
              }
            }
          }
          .el-tree-node__content:hover {
            .custom-tree-node {
              .tree-node-title {
                color: #3296fa;
              }
            }
          }
        }
        .el-tree--highlight-current
          .el-tree-node.is-current
          > .el-tree-node__content {
          .custom-tree-node-list {
            line-height: 28px;
            background-color: #eff7ff;
          }
          .custom-tree-node {
            line-height: 28px;
            background-color: #eff7ff;
            .tree-node-title {
              color: #3296fa;
            }
          }
        }
      }
    }
    .one-right {
      display: inline-block;
      width: calc(100% - 224px);
    }
    .third-do-btn {
      height: 32px;
      line-height: 32px;
      font-size: 0;
      background-color: #fff;
      position: relative;
      .do-btn-left {
        display: inline-block;
        vertical-align: top;
      }
      .do-btn-right {
        margin-left: 8px;
        display: inline-block;
      }
      .do-btn-right-right {
        display: inline-block;
        position: absolute;
        right: 8px;
      }
      .do-btn-two {
        vertical-align: middle;
        // width: 48px;
        height: 24px;
        font-size: 12px;
      }
      .do-btn-shu {
        margin-left: 4px;
        width: 1px;
        height: 15px;
        background-color: #d4d4d7;
        display: inline-block;
        vertical-align: middle;
      }
      .do-btn-check {
        vertical-align: top;
        display: inline-block;
        height: 32px;
        line-height: 32px;
        .el-checkbox {
          line-height: 32px;
        }
      }
      .btn-check-span {
        margin-left: 4px;
        display: inline-block;
        font-size: 12px;
        color: #2e3f57;
      }
      .do-btn-hign-list {
        display: inline-block;
        vertical-align: top;
      }
      .do-btn-four {
        vertical-align: middle;
        // width: 72px;
        height: 24px;
        font-size: 12px;
      }
    }
    .third-table {
      width: 100%;
      .el-table__body-wrapper {
        height: calc(100vh - 120px);
        overflow-y: auto;
      }
    }
    .third-tableTwo {
      width: 100%;
      .el-table__body-wrapper {
        height: calc(100vh - 240px);
        overflow-y: auto;
      }
      .el-button {
        margin-left: 0 !important;
      }
    }
    .third-tableThree {
      width: 100%;
      .el-table__body-wrapper {
        height: calc(100vh - 272px);
        overflow-y: auto;
      }
      .el-button {
        margin-left: 0 !important;
      }
    }
    .third-page {
      padding: 4px 0 0 0;
      text-align: right;
      .el-pagination {
        font-weight: normal;
      }
    }
  }
}
.el-tree-node__content > .el-tree-node__expand-icon > span {
  line-height: 16px;
}
html::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
}
html::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #d4d4d7;
}
.avue-sidebar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 20px;
}
.avue-sidebar::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #d4d4d7;
}
.third-formOne::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 20px;
}
.third-formOne::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #d4d4d7;
}
.left-tree::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 20px;
}
.left-tree::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #d4d4d7;
}
.el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 20px;
}
.el-table__body-wrapper::-webkit-scrollbar-track {
  border: 1px solid #efeff4;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #d4d4d7;
}
.el-dialog__body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 20px;
}
.el-dialog__body::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #d4d4d7;
}
textarea::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 20px;
}
textarea::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #d4d4d7;
}
.basic-table-canScroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 20px;
}
.basic-table-canScroll::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #d4d4d7;
}
.dynamic-list::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 20px;
}
.dynamic-list::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #d4d4d7;
}
// 表格操作中间的线
.table-middle_line {
  display: inline-block;
  height: 13px;
  width: 1px;
  margin: 5px 10px;
  background-color: #dce4ed;
  vertical-align: middle;
}
</style>
